// 서버 DATETIME('2026-10-01 00:00:00')을 KST 기준 Date 로 변환한다.
// 오프셋(+09:00)을 붙여야 접속자의 기기 시간대와 무관하게 모두 같은 순간으로 해석된다.
// 값이 비어 있거나 형식이 다르면 null 을 돌려준다.
export const parseKstDateTime = (value) => {
  const text = String(value ?? "").trim();
  if (!text) return null;

  const normalized = text.replace(" ", "T").slice(0, 19);
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/.test(normalized)) return null;

  const withSeconds =
    normalized.length === 16 ? `${normalized}:00` : normalized;
  const date = new Date(`${withSeconds}+09:00`);

  return Number.isNaN(date.getTime()) ? null : date;
};
